import { API_URL } from "../api/client";

/** docs/04 §9: relative SPA paths, or absolute URLs whose origin is the API origin. */
export function safeReturnTo(value: string | null | undefined): string | null {
  if (!value) return null;
  if (value.startsWith("/") && !value.startsWith("//")) return value;
  try {
    const url = new URL(value);
    if (url.origin === new URL(API_URL).origin) return value;
  } catch {
    return null;
  }
  return null;
}

export function navigateAfterAuth(
  returnTo: string | null,
  navigate: (path: string) => void,
): void {
  const safe = safeReturnTo(returnTo);
  if (safe && safe.startsWith("/")) {
    navigate(safe);
  } else if (safe) {
    window.location.assign(safe);
  } else {
    navigate("/account");
  }
}
